import React from "react";
import "./index.m.css";
const optimizeImageUrl = (url, width, quality) => {
  if (!url || typeof url !== "string") return url;
  try {
    const u = new URL(url);
    if (width) u.searchParams.set("w", width);
    if (quality) u.searchParams.set("q", quality);
    u.searchParams.set("auto", "format,compress");
    return u.toString();
  } catch (e) {
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}w=${width}${quality ? `&q=${quality}` : ""}&auto=format,compress`;
  }
};

export const HeaderSection = ({ data = {} }) => {
  const { hero_section = {} } = data;

  return (
    <section
      styleName="heroSection"
      style={{ backgroundImage: `url(${optimizeImageUrl(hero_section.background_image, 1920)})` }}
    >
      <div styleName="headerTop">
        <button styleName="backButton" aria-label="Go Back" onClick={() => window.history.back()}>
          <svg styleName="backIcon" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.1 12L12.5667 19.4667L10.6667 21.3333L0 10.6667L10.6667 0L12.5667 1.86667L5.1 9.33333H21.3333V12H5.1Z"
              fill="#C78D3C"
            />
          </svg>
        </button>
        <div styleName="logoWrapper">
          <a href="/" styleName="headerLogo">
            <img src="/icons/DHicon.svg" alt="DH Logo" style={{ width: "100%", height: "100%", display: "block" }} />
          </a>
        </div>
        <div styleName="premiumBadge">
          <img
            src="https://thumbor-stg.assettype.com/prajavani2/2026-05-26/vz8c16hs/Small.svg"
            alt="Premium"
            styleName="premiumBadgeIcon"
          />
          <span styleName="premiumBadgeText">PREMIUM</span>
        </div>
        <div styleName="premiumHeading">{hero_section.heading_text}</div>
        <div styleName="premiumSubheading">{hero_section.subheading_text}</div>
      </div>
    </section>
  );
};
